import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function animateStaffSection(grid, tiles) {

  // Individual tweens 
  // Staff grid tiles 
  let tilesTween = tiles ? gsap.to(tiles, {
    duration: 0.8,
    scale: 1,
    opacity: 1,
    stagger: {
      each: 0.25,
      ease: "none",
      from: "start",
    },
  }) : null;

  // Timeline
  // Staff grid timeline
  let tl = gsap.timeline({
    scrollTrigger: {
      trigger: grid,
      start: "top 80%",
    },
  });

  tl.add(tilesTween);

}